import InterestManagement from '@/app/interest-management/InterestManagement.vue';
import { ConfigurationProvider } from '@/app/interest-management/providers/configuration.provider';
import { InterestManagementControllerProvider } from '@/app/interest-management/providers/interest-management.controller-provider';
import { TranslationPlugin } from '@/plugins/translation.plugin';
import { createApp } from 'vue';

const config = new ConfigurationProvider('interest-management.js');
const instance = createApp(InterestManagement);

instance.use(new TranslationPlugin(config.getTranslationConfiguration()));
instance.use(new InterestManagementControllerProvider(config));

instance.mount('#interest-management');
